import loadable from '@loadable/component'
import Loading from '../components/loading/Loading'

export const LoadingComponent = Loading

const fallback = { fallback: <Loading /> }

export const LoadableDashboard = loadable(
  () => import('./dashboard/Dashboard'),
  fallback,
)
export const LoadableDealerTable = loadable(
  () => import('./dealerTable'),
  fallback,
)
export const LoadableResponseRatesPage = loadable(
  () => import('./responseRates/ResponseRatesPage'),
  fallback,
)

// Auth Pages
export const LoadableLogin = loadable(() => import('./login/Login'), fallback)
export const LoadableForgotPassword = loadable(
  () => import('./forgotPassword/ForgotPasswordPage'),
  fallback,
)
